// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__tc1Ro","textNotFound":"NotFound_textNotFound__7AYEo","notFoundContainer":"NotFound_notFoundContainer__lmx1j","isCenter":"NotFound_isCenter__yc-km"};